import React from "react";

interface Props {
  hasActiveRound: boolean;
  onPlay: () => void;
  onResume: () => void;
  onPlayers: () => void;
  onHistory: () => void;
}

// CaddieGames landing screen. Three actions stacked vertically; the
// primary action swaps between Play and Resume depending on whether
// an active round is currently persisted.
export default function Landing({
  hasActiveRound,
  onPlay,
  onResume,
  onPlayers,
  onHistory,
}: Props) {
  return (
    <div className="cg-landing">
      <button
        type="button"
        className="cg-launch-card cg-launch-card-primary"
        onClick={hasActiveRound ? onResume : onPlay}
      >
        <span className="cg-launch-title">
          {hasActiveRound ? "Resume" : "Play"}
        </span>
        <span className="cg-launch-sub">
          {hasActiveRound
            ? "Pick up where you left off"
            : "Pick a course and tee off"}
        </span>
      </button>

      <button type="button" className="cg-launch-card" onClick={onPlayers}>
        <span className="cg-launch-title">Players</span>
        <span className="cg-launch-sub">Manage your regulars</span>
      </button>

      <button type="button" className="cg-launch-card" onClick={onHistory}>
        <span className="cg-launch-title">History</span>
        <span className="cg-launch-sub">Past rounds</span>
      </button>

      <img
        className="cg-landing-logo"
        src={`${process.env.PUBLIC_URL}/CaddieGamesLogo.png`}
        alt="CaddieGames"
      />
    </div>
  );
}
